var map = {
	"./Holligate Signature Demo.ttf": 9048,
	"./background_1.webp": 2768,
	"./background_2.webp": 4948,
	"./background_3.png": 7356,
	"./background_4.png": 7284,
	"./champagne.png": 7704,
	"./disco-ball.png": 9724,
	"./glass.png": 3212,
	"./google-maps.png": 384,
	"./logo.png": 656,
	"./protein.png": 7156,
	"./taxi.png": 8665,
	"./traffic-jam.png": 1600,
	"./waze_logo.svg": 6452,
	"./whatsapp.png": 8344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 372;